/* zhipu r1788508356631 header-bag-sync */
/* 询价袋(janm 逻辑与样式复刻):悬浮袋 + janm 原版抽屉结构 + MOQ倍数步进 + 每项备注 + 询价单表单 */
(function(){
  var localeParam = (new URLSearchParams(location.search).get('lang') || '').toLowerCase();
  var locale = localeParam || (document.documentElement.dataset && document.documentElement.dataset.saulemLocale) || location.pathname.split('/')[1] || 'en';
  var ZH = locale === 'zh';
  var T = ZH ? {
    bag: '询盘袋', added: '已加入 ✓', empty: '从一款产品开始询价。',
    emptyTip: '选择一款可供应的 SAULEM 产品，再补充数量、包装、市场和联系方式。',
    drawerEyebrow: '本地询盘清单', drawerTitle: '你的询盘', close: '关闭询盘',
    remove: '移除', decQty: '减少数量', incQty: '增加数量', qtyOf: '数量',
    moqHelp: function(m){ return '起订量：' + m + ' 个。 起订 ' + m + '，按 ' + m + ' 的倍数增加。'; },
    note: '备注', notePh: '包装、香气或规格要求',
    review: '查看询盘', clear: '清空询盘', send: '整理报价需求', back: '返回询盘清单',
    name: '姓名', market: '目标市场', contact: '联系方式', msg: '补充说明',
    namePh: '请输入姓名', marketPh: '国家或地区', contactPh: 'Email、WhatsApp 或 Telegram',
    sent: '已记录 ✓', sentTip: '演示环境：询价内容已保存在本地，正式上线后可发送给你的团队。',
    srDrawer: '查看本地保存的产品和数量。'
  } : {
    bag: 'Inquiry bag', added: 'Added ✓', empty: 'Start your inquiry with one product.',
    emptyTip: 'Choose an available SAULEM product, then add quantity, packaging, market and contact details.',
    drawerEyebrow: 'Saved locally', drawerTitle: 'Your inquiry', close: 'Close inquiry',
    remove: 'Remove', decQty: 'Decrease quantity', incQty: 'Increase quantity', qtyOf: 'quantity',
    moqHelp: function(m){ return 'MOQ: ' + m + ' units. Starts at ' + m + ', increases in multiples of ' + m + '.'; },
    note: 'Note', notePh: 'Packaging, fragrance or spec requests',
    review: 'Review inquiry', clear: 'Clear inquiry', send: 'Prepare quote request', back: 'Back to inquiry list',
    name: 'Name', market: 'Target market', contact: 'Contact', msg: 'Additional request',
    namePh: 'Your name', marketPh: 'Country or region', contactPh: 'Email, WhatsApp or Telegram',
    sent: 'Saved ✓', sentTip: 'Demo: your inquiry is stored locally and ready to send to your team.',
    srDrawer: 'View locally saved products and quantities.'
  };
  var ICON = {
    x: '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>',
    trash: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line></svg>',
    minus: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path></svg>',
    plus: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>',
    bag: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path><path d="M3 6h18"></path><path d="M16 10a4 4 0 0 1-8 0"></path></svg>'
  };
  var KEY = 'liInquiryBag';
  function load(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
  function save(){ try { localStorage.setItem(KEY, JSON.stringify(items)); } catch(e){} }
  function num(n){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  var items = load();
  var reviewFields = { name: '', market: '', contact: '', msg: '' };
  var preparedQuote = '';
  var previousOverflow = '';

  /* ---------- 悬浮询价袋按钮 ---------- */
  var bagBtn = document.createElement('button');
  bagBtn.type = 'button'; bagBtn.className = 'li-bag-fab'; bagBtn.setAttribute('aria-label', T.bag);
  bagBtn.innerHTML = ICON.bag;
  var badge = document.createElement('span'); bagBtn.appendChild(badge);

  /* ---------- 命名空间包装(janm 样式作用域) ---------- */
  var zone = document.createElement('div');
  zone.className = 'li-merge-zone janm-soul-vars';
  zone.id = 'saulem-inquiry-portal';
  zone.setAttribute('aria-hidden','true');
  var inner = document.createElement('div');
  inner.className = 'janm-v2';
  var backdrop = document.createElement('div'); backdrop.className = 'v2-inquiry-backdrop';
  var drawer = document.createElement('aside');
  drawer.className = 'v2-inquiry-drawer'; drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-modal', 'true');
  drawer.setAttribute('data-state', 'closed');
  inner.appendChild(backdrop); inner.appendChild(drawer); zone.appendChild(inner);

  function boot(){
    document.body.appendChild(bagBtn);
    document.body.appendChild(zone);
    renderBadge();
    bindButtons();
    /* 主题头部/页脚的询盘入口与原站共用同一抽屉。 */
    window.__liOpenBag = openDrawer;
    document.addEventListener('click', function(e){
      var btn = e.target && e.target.closest ? e.target.closest('button,a') : null;
      if (!btn || btn === bagBtn || zone.contains(btn)) return;
      var label = ((btn.getAttribute('aria-label') || '') + ' ' + (btn.textContent || '')).trim();
      if (btn.classList.contains('v2-bag-button') || /询盘袋|inquiry bag|quote bag|打开询盘/.test(label.toLowerCase())) {
        e.preventDefault();
        openDrawer();
      }
    });
  }
  function renderBadge(){ badge.textContent = items.length; badge.style.display = items.length ? 'flex' : 'none'; }
    /* 同步原站 header 询盘按钮：数字 + aria-label（与母站 .v2-bag-count 行为一致，0 也显示） */
    var hc = document.querySelector('.v2-bag-count');
    if (hc) hc.textContent = items.length;
    var hb = document.querySelector('.v2-bag-button');
    if (hb) hb.setAttribute('aria-label', 'Open inquiry bag: ' + items.length);

  /* ---------- 抽屉内容(janm 原版结构) ---------- */
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;'); }
  function escAttr(s){ return esc(s).replace(/"/g,'&quot;'); }
  function suggestions(){
    var seen = {};
    return Array.prototype.slice.call(document.querySelectorAll('.v2-product-card')).filter(function(card){
      var action = card.querySelector('.v2-product-action, .li-detail-inquiry-action');
      var title = card.querySelector('.v2-product-heading h3, h3');
      return action && title && !seen[title.textContent.trim()] && (seen[title.textContent.trim()] = true);
    }).slice(0, 3).map(function(card){
      var title = card.querySelector('.v2-product-heading h3, h3');
      var img = card.querySelector('.v2-product-media img');
      var dims = card.querySelector('.v2-product-heading p');
      var moqNode = card.querySelector('.v2-product-terms dd');
      return { card: card, name: title.textContent.trim(), img: img ? img.getAttribute('src') || '' : '', dims: dims ? dims.textContent.trim() : '', moq: parseInt((moqNode ? moqNode.textContent : '').replace(/[^0-9]/g,''),10) || 1 };
    });
  }
  function renderDrawer(){
    var head = '<p class="v2-sr-only">' + T.srDrawer + '</p>' +
      '<div class="v2-drawer-head"><div><p class="v2-eyebrow">' + T.drawerEyebrow + '</p><h2>' + T.drawerTitle + '</h2></div>' +
      '<button class="v2-icon-button" type="button" data-act="close" aria-label="' + T.close + '">' + ICON.x + '</button></div>';
    var body;
    if (!items.length) {
      var picks = suggestions();
      var pickHtml = picks.map(function(p){
        return '<button class="li-empty-product" type="button" data-act="add-suggest" data-name="' + esc(p.name) + '">' +
          '<img alt="" loading="lazy" src="' + esc(p.img) + '"><span><strong>' + esc(p.name) + '</strong><small>MOQ ' + num(p.moq) + ' ' + (ZH ? '件' : 'units') + '</small></span><em>＋ ' + (ZH ? '从这款开始' : 'Start with this') + '</em></button>';
      }).join('');
      body = '<div class="v2-drawer-body"><div class="v2-inquiry-items v2-inquiry-empty">' +
        '<div class="li-empty-icon" aria-hidden="true">' + ICON.bag + '</div><h3>' + T.empty + '</h3><p>' + T.emptyTip + '</p>' +
        (pickHtml ? '<div class="li-empty-picks" aria-label="' + (ZH ? '可供询价的产品建议' : 'Suggested products') + '">' + pickHtml + '</div>' : '') +
        '<a class="v2-text-link" href="/collections/all">' + (ZH ? '按品类查看' : 'Explore by category') + '</a></div></div>';
    } else {
      var rows = items.map(function(it, i){
        return '<article class="v2-inquiry-item">' +
          '<picture style="display: contents;"><img alt="" loading="lazy" src="' + it.img + '"></picture>' +
          '<div class="v2-inquiry-item-content">' +
          '<div class="v2-inquiry-item-title"><div><h3>' + esc(it.name) + '</h3><p>' + esc(it.dims) + '</p></div>' +
          '<button class="v2-icon-button v2-remove-button" type="button" data-act="rm" data-i="' + i + '" aria-label="' + T.remove + ' ' + esc(it.name) + '">' + ICON.trash + '</button></div>' +
          '<div class="v2-quantity-control">' +
          '<button type="button" data-act="dec" data-i="' + i + '" aria-label="' + T.decQty + '">' + ICON.minus + '</button>' +
          '<label><span class="v2-sr-only">' + esc(it.name) + ' ' + T.qtyOf + '</span>' +
          '<input min="' + it.moq + '" inputmode="numeric" type="number" value="' + it.qty + '" data-act="qty" data-i="' + i + '"></label>' +
          '<button type="button" data-act="inc" data-i="' + i + '" aria-label="' + T.incQty + '">' + ICON.plus + '</button></div>' +
          '<p class="v2-quantity-help">' + T.moqHelp(num(it.moq)) + '</p>' +
          '<label class="v2-note-field"><span>' + T.note + '</span><textarea rows="2" placeholder="' + T.notePh + '" data-act="note" data-i="' + i + '">' + esc(it.note || '') + '</textarea></label>' +
          '</div></article>';
      }).join('');
      body = '<div class="v2-drawer-body"><div class="v2-inquiry-items">' + rows + '</div>' +
        '<div class="v2-drawer-actions">' +
        '<button class="v2-button v2-button-primary" type="button" data-act="review">' + T.review + '</button>' +
        '<button class="v2-text-button" type="button" data-act="clear">' + T.clear + '</button>' +
        '</div></div>';
    }
    drawer.innerHTML = head + body;
  }
  function renderReview(){
    var rows = items.map(function(it){
      return '<li>' + esc(it.name) + ' × ' + num(it.qty) + '（' + T.moqHelp(num(it.moq)).split('。')[0] + '）' +
             (it.note ? ' · ' + T.note + ': ' + esc(it.note) : '') + '</li>';
    }).join('');
    drawer.innerHTML = '<div class="v2-drawer-head"><div><p class="v2-eyebrow">' + T.drawerEyebrow + '</p><h2>' + T.review + '</h2></div>' +
      '<button class="v2-icon-button" type="button" data-act="close" aria-label="' + T.close + '">' + ICON.x + '</button></div>' +
      '<div class="v2-drawer-body"><ul class="v2-review-summary">' + rows + '</ul>' +
      '<label class="v2-note-field"><span>' + T.name + '</span><input class="li-review-f" data-f="name" value="' + escAttr(reviewFields.name) + '" placeholder="' + T.namePh + '"></label>' +
      '<label class="v2-note-field"><span>' + T.market + '</span><input class="li-review-f" data-f="market" value="' + escAttr(reviewFields.market) + '" placeholder="' + T.marketPh + '"></label>' +
      '<label class="v2-note-field"><span>' + T.contact + '</span><input class="li-review-f" data-f="contact" value="' + escAttr(reviewFields.contact) + '" placeholder="' + T.contactPh + '"></label>' +
      '<label class="v2-note-field"><span>' + T.msg + '</span><textarea rows="3" class="li-review-f" data-f="msg" placeholder="' + T.notePh + '">' + esc(reviewFields.msg) + '</textarea></label>' +
      '<div class="v2-drawer-actions">' +
      '<button class="v2-button v2-button-primary" type="button" data-act="send">' + T.send + '</button>' +
      '<button class="v2-text-button" type="button" data-act="back">' + T.back + '</button></div></div>';
  }
  function buildQuote(){
    var lines = items.map(function(it){ return '- ' + it.name + ' × ' + num(it.qty) + (it.note ? ' · ' + T.note + ': ' + it.note : ''); }).join('\n');
    return (ZH ? 'SAULEM 报价需求' : 'SAULEM quote request') + '\n' + lines +
      '\n\n' + T.name + ': ' + (reviewFields.name || '-') +
      '\n' + T.market + ': ' + (reviewFields.market || '-') +
      '\n' + T.contact + ': ' + (reviewFields.contact || '-') +
      '\n' + T.msg + ': ' + (reviewFields.msg || '-');
  }
  function renderPrepared(){
    var wa = 'https://wa.me/8619925142972?text=' + encodeURIComponent(preparedQuote);
    var tg = 'https://t.me/share/url?url=' + encodeURIComponent(location.origin) + '&text=' + encodeURIComponent(preparedQuote);
    drawer.innerHTML = '<div class="v2-drawer-head"><div><p class="v2-eyebrow">' + T.drawerEyebrow + '</p><h2>' + T.review + '</h2></div>' +
      '<button class="v2-icon-button" type="button" data-act="close" aria-label="' + T.close + '">' + ICON.x + '</button></div>' +
      '<div class="v2-drawer-body"><div class="v2-chat-bubble" style="white-space:pre-line">' + esc(preparedQuote) + '</div>' +
      '<p class="li-prepared-hint">' + (ZH ? '内容已整理好，请复制后发送给 SAULEM 团队。' : 'Your inquiry is ready. Copy it and send it to the SAULEM team.') + '</p>' +
      '<div class="v2-drawer-actions"><a class="v2-button v2-button-primary" target="_blank" rel="noreferrer" href="' + wa + '">' + (ZH ? '发送到 WhatsApp' : 'Send on WhatsApp') + '</a>' +
      '<a class="v2-button v2-button-secondary" target="_blank" rel="noreferrer" href="' + tg + '">' + (ZH ? '打开 Telegram' : 'Open Telegram') + '</a>' +
      '<button class="v2-button v2-button-secondary" type="button" data-act="copy">' + (ZH ? '复制询价内容' : 'Copy inquiry') + '</button>' +
      '<button class="v2-text-button" type="button" data-act="back">' + T.back + '</button></div></div>';
  }
  function openDrawer(){
    if (drawer.getAttribute('data-state') !== 'open') { zone.setAttribute('aria-hidden','false'); previousOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; }
    renderDrawer(); backdrop.setAttribute('data-state','open'); drawer.setAttribute('data-state','open');
  }
  function closeDrawer(){
    backdrop.setAttribute('data-state','closed'); drawer.setAttribute('data-state','closed'); zone.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow = previousOverflow;
  }
  function normalizeQty(value, moq){
    var v = parseInt(String(value).replace(/[^0-9]/g,''), 10);
    moq = Math.max(1, parseInt(moq, 10) || 1);
    if (!v || v < moq) return moq;
    return Math.ceil(v / moq) * moq;
  }

  backdrop.addEventListener('click', closeDrawer);
  bagBtn.addEventListener('click', openDrawer);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer.getAttribute('data-state') === 'open') closeDrawer(); });

  drawer.addEventListener('click', function(e){
    var t = e.target.closest ? e.target.closest('button') : null;
    if (!t) return;
    var act = t.getAttribute('data-act'), i = +(t.getAttribute('data-i') || -1);
    if (act === 'close') closeDrawer();
    else if (act === 'rm') { items.splice(i, 1); save(); renderBadge(); renderDrawer(); }
    else if (act === 'inc' && items[i]) { items[i].qty = normalizeQty(items[i].qty + items[i].moq, items[i].moq); save(); renderDrawer(); }
    else if (act === 'dec' && items[i]) { items[i].qty = Math.max(items[i].moq, normalizeQty(items[i].qty - items[i].moq, items[i].moq)); save(); renderDrawer(); }
    else if (act === 'clear') { items = []; save(); renderBadge(); renderDrawer(); }
    else if (act === 'review' && items.length) renderReview();
    else if (act === 'back') renderDrawer();
    else if (act === 'add-suggest') {
      var chosen = suggestions().filter(function(p){ return p.name === t.getAttribute('data-name'); })[0];
      if (chosen) { items.push({name:chosen.name, dims:chosen.dims, img:chosen.img, moq:chosen.moq, qty:chosen.moq, note:''}); save(); renderBadge(); openDrawer(); }
    }
    else if (act === 'send') { preparedQuote = buildQuote(); renderPrepared(); }
    else if (act === 'copy') {
      if (!preparedQuote) return;
      try { navigator.clipboard && navigator.clipboard.writeText(preparedQuote); } catch(e) {}
      var hint = drawer.querySelector('.li-prepared-hint'); if (hint) hint.textContent = ZH ? '已复制，可以粘贴到 WhatsApp、Telegram 或邮件。' : 'Copied. Paste it into WhatsApp, Telegram or email.';
    }
  });
  drawer.addEventListener('change', function(e){
    var t = e.target;
    var act = t.getAttribute('data-act');
    if (act === 'qty') {
      var i = +t.getAttribute('data-i');
      var v = parseInt(t.value.replace(/[^0-9]/g, ''), 10);
      v = normalizeQty(v, items[i].moq);
      items[i].qty = v; save(); t.value = v;
    }
  });
  drawer.addEventListener('input', function(e){
    var t = e.target;
    if (t.getAttribute('data-act') === 'note') {
      items[+t.getAttribute('data-i')].note = t.value; save();
    }
    if (t.classList && t.classList.contains('li-review-f')) reviewFields[t.getAttribute('data-f')] = t.value;
  });

  /* ---------- 产品卡「加入询盘」---------- */
  function bindButtons(){
    document.querySelectorAll('.li-merge-zone .v2-product-action, .li-merge-zone .li-detail-inquiry-action').forEach(function(btn){
      if (btn.__liBound) return; btn.__liBound = true;
      var card = btn.closest('.v2-product-card');
      var detail = btn.closest('.v2-product-detail-page');
      if (!card && !detail) return;
      var scope = card || detail;
      var name = ((card ? card.querySelector('h3') : detail.querySelector('h1')) || {}).textContent || 'product';
      var dims = ((card ? card.querySelector('.v2-product-heading p') : detail.querySelector('.v2-product-summary-kicker span:last-child')) || {}).textContent || '';
      dims = dims.trim();
      var imageNode = card ? card.querySelector('.v2-product-media img') : detail.querySelector('.v2-product-main-media img');
      var img = imageNode && imageNode.getAttribute ? imageNode.getAttribute('src') : '';
      var moqNode = card ? card.querySelector('.v2-product-terms dd') : detail.querySelector('.v2-product-commercial-facts dd');
      var moq = parseInt(((moqNode || {}).textContent || '0').replace(/[^0-9]/g, ''), 10) || 1;
      var svg = btn.querySelector('svg');
      btn.addEventListener('click', function(){
        var found = items.filter(function(it){ return it.name === name; })[0];
        if (found) found.qty += moq;
        else items.push({ name: name, dims: dims, img: img, moq: moq, qty: moq, note: '' });
        save(); renderBadge();
        openDrawer();
        var sr = scope.querySelector('.v2-sr-only');
        if (sr) sr.textContent = name + ' → ' + T.bag;
        if (svg) svg.style.display = 'none';
        btn.dataset.old = btn.dataset.old || btn.textContent;
        btn.textContent = T.added;
        setTimeout(function(){
          btn.textContent = btn.dataset.old;
          if (svg) { svg.style.display = ''; btn.insertBefore(svg, btn.firstChild); }
        }, 1400);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
